import React from 'react'
import { Box, Button, Grid, Slide, TextField, } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import Dialog from '@mui/material/Dialog';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { sendFeedback } from 'utils/APIs';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const SendFeedback = ({ open, setopenForm,feedbackId }) => {
    const { t } = useTranslation()

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData(e.target);
        const formData = JSON.stringify({
            message: data.get('message')
        });

        if (data.get('message')) {
            try {
                await sendFeedback(formData,feedbackId);
                toast.success('Feedback send Sucessfully');
            } catch (error) {
                toast.error(error?.response?.data?.message || error?.message);
            }
            e.target.reset();
            setopenForm(!open)
            return;
        }
        toast.error('Feedback message is required while creating Feedback.');


    }

    return (
        <div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth="sm"
            >
                <Button
                    variant="secondary"
                    onClick={() => setopenForm(!open)}
                    className="text-center"
                >
                    {t("Close X")}
                </Button>
                <MainCard title="Send Feedback" contentClass="card-content">
                    <form noValidate onSubmit={handleFormSubmit}>

                        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item xs={12}>
                                <TextField
                                    id="outlined-adornment--Description"
                                    placeholder="Feedback Message"
                                    name="message"
                                    label="Feedback Message"
                                    fullWidth
                                    variant="outlined"
                                    multiline
                                    rows={4} 
                                />
                            </Grid>
                        </Grid>

                        <Box sx={{ mt: 2 }}>
                            <AnimateButton>
                                <Button fullWidth size="large" type="submit" variant="contained" color="secondary">
                                    {t("Send Feedback")}
                                </Button>
                            </AnimateButton>
                        </Box>
                    </form>
                </MainCard>
            </Dialog>
        </div>
    )
}

export default SendFeedback